<app-navbar></app-navbar>

<div class="bg-white">
    <div class="bg-gradient-hero sliders">
        <div class="mt-28 pb-10 pt-12 px-4 md:px-20 lg:px-28">
            <div class="text-center">
                <div class="green-header mt-3 mb-7">{{ 'integrationsHeader.title' | translate }}</div>
                <div class="gray-header max-w-lg 2xl:max-w-3xl mx-auto" [innerHTML]="'integrationsHeader.description' | translate">
                </div>
            </div>
            <div class="mx-6 sm:mx-2 lg:mx-10 mt-10">
                <img src="../../assets/img/login/integrations.webp" alt="integrations" class="w-full hidden sm:block">
                <img src="../../assets/img/login/integrationsM.webp" alt="integrations" class="w-full sm:hidden">
            </div>
        </div>
    </div>
</div>
<div class="pt-10 pb-6 px-4 md:px-20 lg:px-28 bg-white">
    <div class="text-center">
        <div class="green-header">{{ 'integrationsHeader.connect' | translate }}</div>
    </div>

    <div class="my-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div *ngFor="let integration of integrations"
            class="p-6 rounded-xl border border-gray-300 flex justify-center flex-col items-center">
            <div class="green-integration">{{ integration.hI_NAME }}</div>
            <div class="gray-integration mt-1">{{ integration.hI_TITLE }}</div>

            <div class="py-8">
                <img [src]="imgPath + integration.hI_IMAGE" [alt]="integration.hI_NAME" class="h-14">
            </div>

            <div class="text-left gray-header" [innerHTML]="integration.hI_DESCRIPTION"></div>

            <div class="w-full mt-4">
                <div (click)="goToIntegration(integration.hI_NAME)"
                    class="w-fit flex items-center gap-2 text-primary cursor-pointer">
                    <span>{{ 'integrationsHeader.knowMore' | translate }}</span>
                    <mat-icon>arrow_forward</mat-icon>
                </div>
            </div>
        </div>
    </div>

    <app-haibu-banner></app-haibu-banner>
</div>

<app-footer></app-footer>